<script>
import { mapActions } from "vuex";
import Wallet from "./Wallet";
import Currency from "@/components/_Shared/Forms/Currency";

export default {
  components: {
    Wallet,
    Currency
  },

  data() {
    return {
      preloader: false,
      payer: { id: "", account: { id: "" } },
      receiver: {
        type: "wallet",
        id: ""
      },
      amount: "",
      description: "",
      completedTransfer: false,
      transferResultImage: "",
      transferResultMessage: ""
    };
  },

  computed: {
    channelId() {
      return `transfer:${this.payer.account.id}`;
    }
  },

  methods: {
    ...mapActions("transfers", ["create"]),
    handleTransferSubmit(image, message, func) {
      this.preloader = false;
      this.completedTransfer = true;
      this.transferResultImage = image;
      this.transferResultMessage = message;
      setTimeout(func, 2500);
    },
    subscribeToChannel() {
      this.$cable._addChannel(
        this.channelId,
        {
          received(data) {
            switch (data.data.to_state) {
              case "failed":
                this.handleTransferSubmit(
                  "/static/cancel.svg",
                  "Não foi possivel realizar a transferência!",
                  () => {
                    this.preloader = false;
                    this.completedTransfer = false;
                    this.$emit("refreshOnError");
                  }
                );
                break;

              case "completed":
                this.handleTransferSubmit(
                  "/static/wallet-withdraw.svg",
                  "Transferência realizada com sucesso!",
                  () => {
                    this.$emit("refresh");
                  }
                );
              default:
                this.preloader = false;
                break;
            }
          }
        },
        this
      );
      this.$cable.subscribe(
        { channel: "TransferChannel", room: this.payer.account.id },
        this.channelId
      );
    },
    setPayer(value) {
      if (this.payer.account.id) this.$cable.unsubscribe(this.channelId);
      this.payer.id = value.paymentGatewayAccount.id;
      this.payer.account.id = value.account.id;
      this.subscribeToChannel();
    },
    setReceiver(value) {
      this.receiver.id = value.wallet.id;
    },
    async submit() {
      let payload = {
        payer: this.payer,
        receiver: this.receiver,
        amount: this.amount,
        description: this.description
      };

      try {
        this.preloader = true;
        await this.create(payload);
      } catch (error) {
        let errorMessage = "Não foi possível realizar a transferencia";
        errorMessage = typeof error === "array" ? error[0].title : errorMessage;

        this.handleTransferSubmit("/static/cancel.svg", errorMessage, () => {
          this.preloader = false;
          this.completedTransfer = false;
        });
        this.$emit("refreshOnError");
      }
    }
  }
};
</script>

<template>
  <v-container fluid class="box">
    <v-layout class="title">TRANSFERÊNCIAS</v-layout>

    <v-layout row justify-space-around wrap>
      <Wallet label="de" @selected="setPayer" />

      <div class="transfer-to">
        <div class="arrow">></div>
        transferir <br />para
      </div>

      <Wallet label="para" @selected="setReceiver" />
    </v-layout>

    <v-layout column align-center justify-center>
      <v-layout row class="title">Valor a ser transferido</v-layout>

      <v-layout row>
        <Currency v-model="amount" label="" />
      </v-layout>

      <v-layout row>
        <v-textarea
          outlined
          color="primary"
          v-model="description"
          label="descrição"
          rows="5"
        />
      </v-layout>
      <v-layout row class="submit-transfer" justify-space-around>
        <v-layout v-if="completedTransfer" class="icon-wallet">
          <v-flex md3><img :src="transferResultImage"/></v-flex>
          <v-flex md9
            ><p class="success-message">{{ transferResultMessage }}</p></v-flex
          >
        </v-layout>
        <v-btn
          v-else
          rounded
          color="primary"
          :loading="preloader"
          @click="submit()"
          dark
          >transferir</v-btn
        >
      </v-layout>
    </v-layout>
  </v-container>
</template>

<style scoped>
.success-message {
  color: var(--purple);
}

.submit-transfer {
  min-width: 240px;
}

.icon-wallet {
  background-color: #fff;
  width: 80px;
  height: 30px;
  margin-top: -15px;
}

.icon-wallet img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  object-position: center;
}

.title {
  font-size: 22px;
}

.v-textarea /deep/ textarea {
  min-width: 240px;
  border: none;
}

.transfer-to {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-transform: uppercase;
  color: var(--purple);
  text-align: center;
  font-size: 14px;
}

.transfer-to .arrow {
  width: 30px;
  height: 30px;
  border: 1px solid var(--purple);
  border-radius: 100%;
  text-align: center;
  line-height: 30px;
  font-size: 20px;
  margin-bottom: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/Transfers/NewTransfer/Index.vue